// extracted by mini-css-extract-plugin
export var button = "_1g-0";
export var buttonContent = "_1g-e";
export var buttonGroup = "_1g-c";
export var dontRestrainIconWidth = "_1g-a";
export var dropdownButton = "_1g-b";
export var iconContainer = "_1g-9";
export var lg = "_1g-4";
export var md = "_1g-3";
export var pending = "_1g-f";
export var sm = "_1g-2";
export var spinner = "_1g-d";
export var squared = "_1g-8";
export var wrapText = "_1g-g";
export var xl = "_1g-5";
export var xs = "_1g-1";
export var xxl = "_1g-6";
export var xxxl = "_1g-7";